module.exports = __webpack_public_path__ + "media/img/pages/companies/cinfo-1c46e2578baded6781ce0d3fb09a32f2.png";